import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'business-list.controllers.forms-label-flag.title',
		defaultMessage: 'We’ve introduced new form labels',
		description:
			'Title of flag providing actions related to filtering the list view by form submitted issues',
	},
	description: {
		id: 'business-list.controllers.forms-label-flag.description',
		defaultMessage: 'To include older submissions in your search, update your filters.',
		description:
			'Description of flag providing actions related to filtering the list view by form submitted issues',
	},
	viewAllLink: {
		id: 'business-list.controllers.forms-label-flag.view-all-link',
		defaultMessage: 'Update filters',
		description: 'Link to filter list view by all issues submitted via forms',
	},
	iconLabel: {
		id: 'business-list.controllers.forms-label-flag.icon-label',
		defaultMessage: 'Alert',
		description: 'Alt text for flag icon',
	},
});
